"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PRODUCT_INFO_HEIGHT = exports.ON_MOUSE_ENTER = exports.FEATURES_COLOR = exports.COMPONENTS = exports.BOX_SHADOW = exports.BORDER = exports.BG_COLOR = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.price"));

var _gerenciatdUnifiedcomponents4 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.claim"));

var _gerenciatdUnifiedcomponents5 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));

var _reactImageAndBackgroundImageFade = require("react-image-and-background-image-fade");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.constants");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.log-utils");

var _index = _interopRequireDefault(require("./PriceBox/index"));

require("./ProductItem.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const BG_COLOR = {
  PURPLE: 'purple',
  WHITE: 'white'
};
exports.BG_COLOR = BG_COLOR;
const BORDER = {
  RADIUS: 'radius',
  STRAIGHT: 'straight'
};
exports.BORDER = BORDER;
const BOX_SHADOW = {
  NONE: 'none',
  DEFAULT: 'default-shadow'
};
exports.BOX_SHADOW = BOX_SHADOW;
const COMPONENTS = {
  TEXT_INFO_1: 'TextInfo-1',
  TEXT_INFO_2: 'TextInfo-2',
  TEXT_INFO_3: 'TextInfo-3',
  CLAIM_1: 'Claim-1',
  PRICE_1: 'Price-1',
  PRICE_2: 'Price-2',
  BUTTON_1: 'Button-1',
  PRICE_BOX: 'Price-box',
  PROMO_BOX: 'Promo-box'
};
exports.COMPONENTS = COMPONENTS;
const FEATURES_COLOR = {
  GREY_5: 'grey5',
  EMP_BLUE_DARK: 'emp-dark-blue',
  EMP_MEDIUM_PURPLE: 'emp-medium-purple'
};
exports.FEATURES_COLOR = FEATURES_COLOR;
const ON_MOUSE_ENTER = {
  DEFAULT: 'default',
  NONE: 'none'
};
exports.ON_MOUSE_ENTER = ON_MOUSE_ENTER;
const PRODUCT_INFO_HEIGHT = {
  DEFAULT: 'default',
  STATIC: 'static'
};
exports.PRODUCT_INFO_HEIGHT = PRODUCT_INFO_HEIGHT;

class ProductItem extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "getMovementAmount", elementAux => {
      let firstExecution = false;
      let {
        element
      } = this.state;
      const {
        onEnterAndLeave
      } = this.props;

      if (!element && elementAux) {
        element = elementAux;
        firstExecution = true;
      }

      const currentDevice = (0, _gerenciatdUtils2.getDeviceKindDependsOnViewPort)();
      let amount = 65;

      switch (currentDevice) {
        case _gerenciatdUtils.DEVICES.MOBILE:
          amount = 110;
          break;
        // nowadays, the animation is not enable on those devices, so it doesnt matter the value

        case _gerenciatdUtils.DEVICES.TABLET:
          amount = 110;
          break;
        // nowadays, the animation is not enable on those devices, so it doesnt matter the value

        default:
          amount = 95;
          break;
      }

      const contentElement = element.getElementsByClassName('productInfoGap_content')[0];
      const amount2 = contentElement.offsetHeight;
      const res = Math.abs(amount2 - amount);
      let {
        hover
      } = this.state;

      if (!firstExecution && onEnterAndLeave) {
        hover = !hover;
        onEnterAndLeave();
      }

      this.setState({
        hover,
        amount: res,
        device: currentDevice
      });
    });

    _defineProperty(this, "componentDidMount", () => {
      const {
        onMouseEnter
      } = this.props;

      if (onMouseEnter === 'default') {
        try {
          const {
            id
          } = this.state;
          const element = document.getElementById(id);
          element.addEventListener('mouseenter', this.onMouseEnter);
          element.addEventListener('mouseleave', this.onMouseLeave);
          window.addEventListener('resize', this.getMovementAmount);
          this.getMovementAmount(element);
          this.setState({
            element
          });
        } catch (err) {
          (0, _gerenciatdUtils3.errorLog)('onMouseEnter', err);
        }
      }

      if (onMouseEnter === 'none') {
        this.setState({
          hover: true
        });
      }
    });

    _defineProperty(this, "componentWillUnmount", () => {
      const {
        onMouseEnter
      } = this.props;
      const {
        element
      } = this.state;

      if (onMouseEnter === 'default') {
        try {
          element.removeEventListener('mouseenter', this.onMouseEnter);
          element.removeEventListener('mouseleave', this.onMouseLeave);
          element.removeEventListener('resize', this.getMovementAmount);
        } catch (err) {
          (0, _gerenciatdUtils3.errorLog)(err);
        }
      }
    });

    _defineProperty(this, "movement", (element, amount, duration) => {
      const s = element.style; // s.top = '0px';

      let y = 0;
      let currentFrame = 0;
      const framerate = 30;
      const oneSecond = 1000;
      const interval = oneSecond * duration / framerate;
      const totalframes = oneSecond * duration / interval;
      const heightincrement = amount / totalframes;

      const tween = () => {
        y += heightincrement;

        if (currentFrame < totalframes) {
          s.top = `${y}px`;
          currentFrame += 1;
          setTimeout(tween, interval);
        }
      };

      tween();
    });

    _defineProperty(this, "onMouseLeave", () => {
      const {
        onEnterAndLeave
      } = this.props;

      if (onEnterAndLeave) {
        onEnterAndLeave();
      }

      const {
        id,
        device,
        hover
      } = this.state;

      if (device === _gerenciatdUtils.DEVICES.PC && hover) {
        this.setState({
          hover: false
        });
        const element = document.querySelector(`#${id} .productInfoGap .productInfoGap_content`);
        this.movement(element, 0, 0.3);
      }
    });

    _defineProperty(this, "onMouseEnter", () => {
      const {
        onEnterAndLeave
      } = this.props;

      if (onEnterAndLeave) {
        onEnterAndLeave();
      }

      const {
        id,
        amount,
        device,
        hover
      } = this.state; // we only animates when it is pc

      if (device === _gerenciatdUtils.DEVICES.PC && !hover) {
        this.setState({
          hover: true
        });
        const element = document.querySelector(`#${id} .productInfoGap .productInfoGap_content`);
        const negativeAmount = -1 * amount;
        this.movement(element, negativeAmount, 0.3);
      }
    });

    const _device = (0, _gerenciatdUtils2.getDeviceKindDependsOnViewPort)();

    const _id = (0, _gerenciatdUtils2.generateComponentId)('ProductItemSH', '');

    this.state = {
      id: _id,
      amount: 0,
      device: _device,
      hover: false
    };
  }

  render() {
    const {
      id,
      amount,
      device,
      hover
    } = this.state;
    const {
      bgColor,
      features,
      featureStyles,
      img,
      brandImg,
      components,
      border,
      boxShadow,
      onMouseEnter,
      segment,
      productInfoHeight,
      taggingInfo
    } = this.props;
    const title = components && components['TextInfo-1'];
    const secondTitle = components && components['TextInfo-2'];
    const description = components && components['TextInfo-3'];
    const claim = components && components['Claim-1'];
    const price1 = components && components['Price-1'];
    const price2 = components && components['Price-2'];
    const button1 = components && components['Button-1'];
    const customLink1 = components && components['CustomLink-1'];
    const priceBox = components && components['Price-box'];
    const promoBox = components && components['Promo-box'];
    const bgColorCss1 = ` productInfoGap_bgColor--${bgColor}-${segment}`;
    const bgColorCss2 = ` productInfoGap_content_bgColor--${bgColor}-${segment}`;
    const opacityBgColorCss = ` opacityLayer opacityLayer--${bgColor}`;
    const titleClass = !priceBox && title.segment === 'emp' ? 'productInfoGap_content_title-margin' : 'title';
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      id: id,
      className: `ProductItem ProductItem__border--${border} ProductItem__box-shadow--${boxShadow}`,
      children: [promoBox && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `promo-box promo-box_bgColor--${promoBox.bgColor}-${segment}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, promoBox.TextInfo))
      }), (brandImg || img) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "pictureGap",
        children: [img && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageAndBackgroundImageFade.BackgroundImage, {
          src: img,
          width: "800px",
          height: "400px",
          wrapperClassName: "productImg",
          isResponsive: true,
          lazyLoad: true
        }), brandImg && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "brandImg",
          alt: "imagenfondo",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: brandImg,
            alt: "brand"
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `productInfoGap productInfoGap_height--${productInfoHeight} ${bgColorCss1}`,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: `productInfoGap_content ${bgColorCss2}`,
          children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, title), {}, {
            className: titleClass
          })), priceBox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default, _objectSpread({
            segment: segment
          }, priceBox)), secondTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, secondTitle), {}, {
            className: "secondTitle"
          })), description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, description), {}, {
            className: "description"
          })), features && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "productInfoGap_content_features",
            children: features.map((feature, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, featureStyles), {}, {
              text: feature
            })))
          }), (price1 || price2 || button1) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: `productInfoGap_content_bottom ${claim && claim.label ? 'withClaim' : ''}`,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "prices_gap",
                children: [claim && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, _objectSpread(_objectSpread({}, claim), {}, {
                  borderColor: "transparent"
                })), price1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread({}, price1)), price2 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread({}, price2))]
              }), button1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread({}, button1))]
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `${opacityBgColorCss}${hover ? ' hidden' : ''}`
        })]
      }), customLink1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
        taggingInfo: _objectSpread(_objectSpread({}, customLink1.taggingInfo), {}, {
          componentName: taggingInfo.componentName
        }),
        link: customLink1.link,
        isBlockElement: true,
        text: "",
        className: "absLink"
      })]
    });
  }

}

ProductItem.propTypes = {
  /**
   * {
   *  "info": "color de fondo",
   *  "kind": "both",
   *  "beautifulName": "bgColor"
   * }
   */
  bgColor: _propTypes.default.oneOf([BG_COLOR.WHITE, BG_COLOR.PURPLE]),

  /**
   * {
   *  "info": "tipo de borde de la tarjeta",
   *  "kind": "both",
   *  "beautifulName": "border"
   * }
   */
  border: _propTypes.default.oneOf([BORDER.RADIUS, BORDER.STRAIGHT]),

  /**
   * {
   *  "info": "opciones box shadow de la tarjeta",
   *  "kind": "both",
   *  "beautifulName": "boxShadow"
   * }
   */
  boxShadow: _propTypes.default.oneOf([BOX_SHADOW.NONE, BOX_SHADOW.DEFAULT]),

  /**
   * {
   *  "info": "listado elementos con información",
   *  "kind": "both",
   *  "beautifulName": "features"
   * }
   */
  features: _propTypes.default.array,

  /**
   * {
   *  "info": "color del texto del listado elementos con información",
   *  "kind": "both",
   *  "beautifulName": "featuresColor"
   * }
   */
  featureStyles: _propTypes.default.array,

  /**
   * {
   *  "info": "imagen de la tarjeta",
   *  "kind": "both",
   *  "beautifulName": "img"
   * }
   */
  img: _propTypes.default.string,

  /**
   * {
   *  "info": "imagen logo",
   *  "kind": "both",
   *  "beautifulName": "brandImg"
   * }
   */
  brandImg: _propTypes.default.string,

  /**
   * {
   *  "info": "función, procedente del componente ProductList, que oculta la flecha al ponerse sobre la tarjeta",
   *  "kind": "both",
   *  "beautifulName": "onEnterAndLeave"
   * }
   */
  onEnterAndLeave: _propTypes.default.func,

  /**
   * {
   *  "info": "función que se activa al poner el ratón sobre la información del producto",
   *  "kind": "both",
   *  "beautifulName": "onEnterAndLeave"
   * }
   */
  onMouseEnter: _propTypes.default.string,

  /**
   * {
   *  "info": "altura de la caja de información del producto, el caso default está pensdo para tener efecto onMouseEnter",
   *  "kind": "both",
   *  "beautifulName": "onEnterAndLeave"
   * }
   */
  productInfoHeight: _propTypes.default.oneOf([PRODUCT_INFO_HEIGHT.DEFAULT, PRODUCT_INFO_HEIGHT.STATIC]),

  /**
   * {
   *  "info": "componentes, tiene que ser uno del array COMPONENTS. El componente PriceBox es un componente interno de ProductItem",
   *  "kind": "both",
   *  "beautifulName": "components"
   * }
   */
  components: _propTypes.default.shape([COMPONENTS.TEXT_INFO_1 // COMPONENTS.TEXT_INFO_2,
  // COMPONENTS.TEXT_INFO_3,
  // COMPONENTS.CLAIM_1,
  // COMPONENTS.PRICE_1,
  // COMPONENTS.PRICE_2,
  // COMPONENTS.BUTTON_1,
  // COMPONENTS.PRICE_BOX,
  ]).isRequired
};
ProductItem.defaultProps = {
  bgColor: BG_COLOR.WHITE,
  features: null,
  featureStyles: null,
  img: null,
  brandImg: null,
  onEnterAndLeave: null,
  border: BORDER.RADIUS,
  boxShadow: BOX_SHADOW.DEFAULT,
  onMouseEnter: ON_MOUSE_ENTER.DEFAULT,
  productInfoHeight: PRODUCT_INFO_HEIGHT.DEFAULT
};
var _default = ProductItem;
exports.default = _default;

//# sourceMappingURL=index.js.map